export default {
  ROOT: '/',
  SETUPACCOUNT: '/setup-account',
};
